import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cdcde82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-editor" }

import { computed, onMounted, PropType, ref, watchEffect } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTElement } from '@/types/slides'
import { AlignmentLineProps } from '@/types/edit'
import { Mode } from '@/types/mobile'
import { VIEWPORT_SIZE } from '@/configs/canvas'
import useSlideBackgroundStyle from '@/hooks/useSlideBackgroundStyle'
import useDragElement from '@/views/Editor/Canvas/hooks/useDragElement'
import useScaleElement from '@/views/Editor/Canvas/hooks/useScaleElement'

import AlignmentLine from '@/views/Editor/Canvas/AlignmentLine.vue'
import MobileEditableElement from './MobileEditableElement.vue'
import MobileOperate from './MobileOperate.vue'
import SlideToolbar from './SlideToolbar.vue'
import ElementToolbar from './ElementToolbar.vue'
import Header from './Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  changeMode: {
    type: Function as PropType<(mode: Mode) => void>,
    required: true,
  },
},
  setup(__props) {



const slidesStore = useSlidesStore()
const mainStore = useMainStore()
const { slideIndex, currentSlide, viewportRatio } = storeToRefs(slidesStore)
const { activeElementIdList, handleElement } = storeToRefs(mainStore)

const contentRef = ref<HTMLElement>()

const alignmentLines = ref<AlignmentLineProps[]>([])

const background = computed(() => currentSlide.value.background)
const { backgroundStyle } = useSlideBackgroundStyle(background)

const canvasScale = computed(() => {
  if (!contentRef.value) return 1
  const contentWidth = contentRef.value.clientWidth
  const contentheight = contentRef.value.clientHeight

  const contentRatio = contentheight / contentWidth
  if (contentRatio >= viewportRatio.value) return (contentWidth - 20) / VIEWPORT_SIZE
  return (contentheight - 20) / viewportRatio.value / VIEWPORT_SIZE
})

onMounted(() => {
  if (activeElementIdList.value.length) mainStore.setActiveElementIdList([])
  if (slideIndex.value !== 0) slidesStore.updateSlideIndex(0)
})

const viewportStyles = computed(() => ({
  width: VIEWPORT_SIZE * canvasScale.value + 'px',
  height: VIEWPORT_SIZE * viewportRatio.value * canvasScale.value + 'px',
}))

const elementList = ref<PPTElement[]>([])
const setLocalElementList = () => {
  elementList.value = currentSlide.value ? JSON.parse(JSON.stringify(currentSlide.value.elements)) : []
}
watchEffect(setLocalElementList)

const { dragElement } = useDragElement(elementList, alignmentLines, canvasScale)
const { scaleElement } = useScaleElement(elementList, alignmentLines, canvasScale)

const selectElement = (e: TouchEvent, element: PPTElement, startMove = true) => {
  if (!activeElementIdList.value.includes(element.id)) {
    mainStore.setActiveElementIdList([element.id])
    mainStore.setHandleElementId(element.id)
  }
  if (startMove) dragElement(e, element)
}

const handleClickBlankArea = () => {
  mainStore.setActiveElementIdList([])
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, { changeMode: __props.changeMode }, null, 8, ["changeMode"]),
    _createElementVNode("div", {
      class: "content",
      ref_key: "contentRef",
      ref: contentRef,
      onTouchstart: _cache[0] || (_cache[0] = ($event: any) => (handleClickBlankArea()))
    }, [
      _createElementVNode("div", {
        class: "viewport-wrapper",
        style: _normalizeStyle(_unref(viewportStyles))
      }, [
        _createElementVNode("div", {
          class: "background",
          style: _normalizeStyle(_unref(backgroundStyle))
        }, null, 4),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alignmentLines.value, (line, index) => {
          return (_openBlock(), _createBlock(AlignmentLine, {
            key: index,
            type: line.type,
            axis: line.axis,
            length: line.length,
            canvasScale: _unref(canvasScale)
          }, null, 8, ["type", "axis", "length", "canvasScale"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elementList.value, (element) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: element.id
          }, [
            (element.type !== 'line')
              ? (_openBlock(), _createBlock(MobileOperate, {
                  key: 0,
                  elementInfo: element,
                  isSelected: _unref(activeElementIdList).includes(element.id),
                  canvasScale: _unref(canvasScale),
                  scaleElement: _unref(scaleElement)
                }, null, 8, ["elementInfo", "isSelected", "canvasScale", "scaleElement"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _createElementVNode("div", {
          class: "viewport",
          style: _normalizeStyle({ transform: `scale(${_unref(canvasScale)})` })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elementList.value, (element, index) => {
            return (_openBlock(), _createBlock(MobileEditableElement, {
              key: element.id,
              elementInfo: element,
              elementIndex: index + 1,
              selectElement: selectElement
            }, null, 8, ["elementInfo", "elementIndex"]))
          }), 128))
        ], 4)
      ], 4)
    ], 544),
    _createVNode(SlideToolbar),
    (_unref(handleElement))
      ? (_openBlock(), _createBlock(ElementToolbar, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})